export function encodeBase64UTF8(str) {
    try {
        const encoder = new TextEncoder();
        const bytes = encoder.encode(str);
        return btoa(String.fromCharCode(...bytes));
    
    } catch (error) {
        console.error('Error saving to cache:', error);
        return ""; // Base64 にエンコード

    }
};


export function decodeBase64UTF8(str) {
    try {
        console.log('decodeBase64UTF8',str)
        const binaryStr = atob(str);
        const bytes = Uint8Array.from(binaryStr, char => char.charCodeAt(0));
        const decoder = new TextDecoder();
        console.log('decodeBase64UTF8',decoder)
        return decoder.decode(bytes);
         
    } catch (error) {
        console.error('Error saving to cache:', error);
        return ""; // Base64 にエンコード
    }
};
